<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer011">
<div class="calibre3"><br class="calibre3"/></div>
<div class="calibre3"><br class="calibre3"/></div>
<div class="calibre3"><br class="calibre3"/></div>
<h1 class="sigil_not_in_toc" title="Dedication"><br class="calibre1"/></h1>
<p class="blcc-book-pages"><span class="charoverride4"><br class="calibre3"/></span></p>
<p class="blcc-book-pages"><span class="charoverride4">To<br class="calibre3"/>Lieutenant A. P. Davies R.H.A.<br class="calibre3"/>and<br class="calibre3"/>Captain D. S. Graham M.C., R.A.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?4497bb9c